import { Button, Popconfirm } from 'antd'
import { FormikProps } from 'formik'
import * as React from 'react'

import { ResetButton } from 'formik-antd'

import { FormValues } from './Form'

export interface ButtonsProps {
	formikBag: FormikProps<FormValues>
	getButtons: (
		buttons: { cancelButton: React.ReactNode; resetButton: React.ReactNode; submitButton: React.ReactNode }
	) => void
	handleCancel?: any
	handleSubmit: any // (values: FormValues, actions: FormikActions<FormValues>) => Promise<void>
	resetButtonName?: string
	showButtons: boolean
	showCancelButton: boolean
	submitButtonName?: string
}

export const Buttons: React.FC<ButtonsProps> = (props) => {
	const {
		getButtons,
		formikBag,
		handleCancel,
		handleSubmit,
		resetButtonName,
		showButtons,
		showCancelButton,
		submitButtonName
	} = props

	const onCancel = () => {
		handleCancel()
	}

	const resetButton = resetButtonName && <ResetButton>{resetButtonName}</ResetButton>
	const cancelButton = showCancelButton ? formikBag.dirty ? (
		<Popconfirm title='Are you sure?' onConfirm={onCancel} okText='Yes' cancelText='No'>
			<Button>Cancel</Button>
		</Popconfirm>
	) : (
		<Button onClick={onCancel}>Cancel</Button>
	) : (
		undefined
	)
	const submitButton = (
		<Button type='primary' htmlType='submit' loading={formikBag.isSubmitting} onClick={handleSubmit}>
			{submitButtonName || 'Save'}
		</Button>
	)

	getButtons && getButtons({ cancelButton, resetButton, submitButton })

	return showButtons ? (
		<div>
			<span>{resetButton}</span>
			<span style={{ marginLeft: '1rem' }}>{cancelButton}</span>
			<span style={{ marginLeft: '1rem' }}>{submitButton}</span>
		</div>
	) : (
		<React.Fragment />
	)
}
